import { useEffect } from 'react'

export type HotKey = 'ctrl' | 'shift' | 'alt' | 'meta' | string

export interface HotKeysShortcut {
    keys: HotKey[]
    callback: () => void
}

const useKeyboardShortcut = (shortcut: HotKeysShortcut) => {
    const { keys, callback } = shortcut

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            const isMatch = keys.every((key) => {
                if (['ctrl', 'shift', 'alt', 'meta'].includes(key)) {
                    return event[`${key}Key` as keyof KeyboardEvent]
                }
                // return event.key.toLowerCase() === key.toLowerCase()
                return event.code === `Key${key.toUpperCase()}`
            })

            if (isMatch) {
                event.preventDefault()
                callback()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => {
            window.removeEventListener('keydown', handleKeyDown)
        }
    }, [keys, callback])
}

export default useKeyboardShortcut
